import React from "react";
import { JoinWrap, Title } from "./styled";
import Button from "shared/Button";
import { colors } from "../../../styles/colors";

const Join = ({ isLogin, isCreator, becomeCreator }) => {
  return (
    <JoinWrap>
      <Title>Ready to join?</Title>
      {isLogin && isCreator ? null : (
        <Button
          bdButton={colors.WHITE}
          color={colors.RED}
          textColor={colors.WHITE}
          text="Become Creator"
          stylType="primary"
          onClick={becomeCreator}
        />
      )}
    </JoinWrap>
  );
};

export default Join;
